import './PlanAssigneeField.style.less'

import { useState } from 'react'
import { EditFilled } from '@ant-design/icons'
import PlanAssigneeFieldModal from './components/PlanDateFieldModal/PlanAssigneeFieldModal'
import PBFPermission from '@/screens/Order/components/PBFPermission'
import {
  COLLABORATOR_ROLE_DOER,
  COLLABORATOR_ROLE_EDITOR,
  COLLABORATOR_ROLE_OWNER,
} from '@/screens/Order/Pages/Order.constant'

interface Prop {
  onSetAssignee: (assignee: any) => void
  fieldName: string
  assignee: any
  taskId: any
}

export function PlanAssigneeField(prop: Prop) {
  const { assignee, onSetAssignee } = prop
  const [showDialog, setshowDialog] = useState(false)

  return (
    <>
      <PBFPermission
        roles={[
          COLLABORATOR_ROLE_OWNER,
          COLLABORATOR_ROLE_EDITOR,
          COLLABORATOR_ROLE_DOER,
        ]}
        showComponent
      >
        <div
          className="field-display-card clickable plan-date-field-container"
          onClick={() => setshowDialog(true)}
        >
          <div className="ant-card-head ">
            <div className="ant-card-head-wrapper">
              <div className="ant-card-head-title">
                <div className="field-content">
                  <div>
                    <span className="font-size-1">
                      {assignee ? (
                        <>
                          <div>
                            <span className="font-size-1">
                              {assignee?.user?.first_name}&nbsp;
                              {assignee?.user?.last_name}
                            </span>
                          </div>
                        </>
                      ) : (
                        <button
                          type="button"
                          className="ant-btn   field-btn-place-holder"
                          style={{ padding: 0, textAlign: 'left' }}
                        >
                          <span>Assign Task</span>
                        </button>
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <PBFPermission
                roles={[
                  COLLABORATOR_ROLE_OWNER,
                  COLLABORATOR_ROLE_EDITOR,
                  COLLABORATOR_ROLE_DOER,
                ]}
              >
                <div className="edit-icon">
                  <EditFilled />
                </div>
              </PBFPermission>
            </div>
          </div>
        </div>
      </PBFPermission>
      {showDialog && (
        <PlanAssigneeFieldModal
          onClose={() => {
            setshowDialog(false)
          }}
          defaultAssignee={prop.assignee}
          fieldName={prop.fieldName}
          onsubmit={(resp: any) => {
            onSetAssignee(resp)
            setshowDialog(false)
          }}
          taskId={prop.taskId}
        />
      )}
    </>
  )
}
